module.exports = __webpack_public_path__ + "assets/images/piramide_0e43e11a8f7e27e1f10121c52816144e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/piramide/piramide.png
// module id = 211
// module chunks = 0